import {
  PartnersRestResource,
  GetPartnersRequest,
  GetPartnersResponse,
  UpdatePartnersDeletionFlagsRequest,
  UpdatePartnersDeletionFlagsResponse,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useGetPartners = () =>
  useRestResourceHook<GetPartnersRequest, GetPartnersResponse>((request) =>
    PartnersRestResource.getPartners(request),
  );

export const useUpdatePartnersDeletionFlags = () =>
  useRestResourceHook<
    UpdatePartnersDeletionFlagsRequest,
    UpdatePartnersDeletionFlagsResponse
  >((request) => PartnersRestResource.updatePartnersDeletionFlags(request));
